/**
 * WordPress Dependencies
 */
import { isEqual } from "lodash";
import { __ } from "@wordpress/i18n";
import { loop, moveTo } from "@wordpress/icons";

/** @typedef {import('@wordpress/blocks').WPBlockVariation} WPBlockVariation */

const QUERY_ATTRIBUTES = {
	pages: 0,
	offset: 0,
	postType: "post",
	order: "desc",
	orderBy: "date",
	author: "",
	search: "",
	exclude: [],
	sticky: "",
	inherit: false,
};

wp.blocks.registerBlockVariation("core/query", {
	title: __("Query Loop", "gutenberg-pro-ext"),
	description: __(
		"An advanced block that allows displaying post types based on different query parameters and visual configurations.",
		"gutenberg-pro-ext",
	),
	icon: loop,
	name: "core/query",
	isDefault: true,
	attributes: {
		gpVariation: "default",
		className: "",
	},
	scope: ["inserter", "transform"],
	isActive: (blockAttributes, variationAttributes) =>
		isEqual(blockAttributes.gpVariation, variationAttributes.gpVariation),
});

wp.blocks.registerBlockVariation("core/query", {
	name: "gutenberghub-collage-query",
	title: __("Pro Post Grid", "gutenberg-pro-ext"),
	description: __(
		"Showcase posts or custom post types in a sleek and engaging collage layout.",
		"gutenberg-pro-ext",
	),
	keywords: ["gutenberg", "collage", "post collage", "query"],
	category: "ghub-products",
	icon: (
		<svg
			width="288"
			height="300"
			viewBox="0 0 288 300"
			style={{ fill: "none" }}
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M249.769 25H38.2308C27.6099 25 19 33.6099 19 44.2308V255.769C19 266.39 27.6099 275 38.2308 275H249.769C260.39 275 269 266.39 269 255.769V44.2308C269 33.6099 260.39 25 249.769 25Z"
				stroke="currentColor"
				strokeWidth="15"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M95.9229 25V275M95.9229 150H269"
				stroke="currentColor"
				strokeWidth="15"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	),
	attributes: {
		gpVariation: "ghub-query-collage",
		className: "ghub-query-collage",
	},
	innerBlocks: [
		[
			"core/post-template",
			{},
			[
				[
					"core/cover",
					{
						useFeaturedImage: true,
						dimRatio: 60,
						isDark: true,
						minHeight: 500,
					},
					[["core/post-title", {}]],
				],
			],
		],
	],
	scope: ["transform", "inserter"],

	isActive: (blockAttributes, variationAttributes) =>
		isEqual(blockAttributes.gpVariation, variationAttributes.gpVariation),
});

wp.blocks.registerBlockVariation("core/query", {
	name: "gutenberghub-query-masonry",
	title: __("Pro Post Masonry", "gutenberg-pro-ext"),
	description: __(
		"Showcase posts or custom post types in a sleek and engaging masonry layout.",
		"gutenberg-pro-ext",
	),
	keywords: ["gutenberg", "masonry", "grid", "query"],
	icon: moveTo,
	attributes: {
		gpVariation: "ghub-query-masonry",
		className: "ghub-query-masonry",
		align: "wide",
		query: {
			...QUERY_ATTRIBUTES,
			perPage: 8,
			inherit: false,
		},
	},

	innerBlocks: [
		[
			"core/post-template",
			{
				layout: {
					type: "grid",
					columnCount: 4,
				},
			},
			[
				[
					"core/cover",
					{
						useFeaturedImage: true,
						dimRatio: 60,
						isDark: true,
						minHeight: 500,
					},
					[
						["core/post-title", { textColor: "base" }],
						["core/post-excerpt", { textColor: "base" }],
					],
				],
			],
		],
	],
	scope: ["transform", "inserter"],

	isActive: (blockAttributes, variationAttributes) =>
		isEqual(blockAttributes.gpVariation, variationAttributes.gpVariation),
});

const variations = [
	{
		name: "gp-post-grid",
		title: __("Pro Post Grid", "gutenberg-pro-ext"),
		icon: (
			<svg
				xmlns="http://www.w3.org/2000/svg"
				width="14"
				height="14"
				viewBox="0 0 14 14"
			>
				<g
					fill="none"
					stroke="currentColor"
					strokeLinecap="round"
					strokeLinejoin="round"
				>
					<rect width="13" height="13" x=".5" y=".5" rx="1" />
					<path d="M4.5.5v13m0-6.5h9" />
				</g>
			</svg>
		),
		attributes: {
			query: {
				...QUERY_ATTRIBUTES,
				perPage: 3,
			},
			gpVariation: "ghub-query-collage",
		},
		innerBlocks: [
			[
				"core/post-template",
				{},
				[
					[
						"core/cover",
						{
							useFeaturedImage: true,
							dimRatio: 60,
							minHeight: 500,
						},
						[["core/post-title", {}]],
					],
				],
			],
		],
		scope: ["block"],
	},

	{
		name: "gp-post-masonry",
		title: __("Pro Post Masonry", "gutenberg-pro-ext"),
		icon: moveTo,
		attributes: {
			align: "wide",
			query: {
				...QUERY_ATTRIBUTES,
				perPage: 8,
				inherit: false,
			},
			gpVariation: "ghub-query-masonry",
			className: "ghub-query-masonry",
		},
		innerBlocks: [
			[
				"core/post-template",
				{ layout: { type: "grid", columnCount: 4 } },
				[
					[
						"core/cover",
						{
							useFeaturedImage: true,
							dimRatio: 60,
							minHeight: 500,
						},
						[
							["core/post-title", { textColor: "base" }],
							["core/post-excerpt", { textColor: "base" }],
						],
					],
				],
			],
		],
		scope: ["block"],
	},
];

export default variations;
